const groupPrefix = 'bookings'

export const apiBooking = {
	fetchBooking: async (uuid: string) => {
		const { data } = await apiCommon<IBooking>(`${groupPrefix}/${uuid}`, {
			method: 'GET',
		})

		return Booking(data)
	},

	fetchBookings: async ({
		status,
		dateInAfter,
		dateInBefore,
		sortByPast,
		sort = 'created_at',
		page = 1,
		perPage = 10,
	}: {
		status?: string
		dateInAfter?: string
		dateInBefore?: string
		sortByPast?: boolean
		sort?: string
		page?: number
		perPage?: number
	}) => {
		const { data, meta } = await apiCommon<IBooking[]>(`${groupPrefix}`, {
			method: 'GET',
			query: {
				'filter[status]': status,
				'filter[date_in_after]': dateInAfter,
				'filter[date_in_before]': dateInBefore,
				sortByPast,
				sort,
				'page[number]': page,
				'page[size]': perPage,
			},
		})

		if (!data) return { data: [], meta }
		return { data: data.map(Booking), meta }
	},

	createBooking: async (request: IBookingStoreRequest, locale: string) => {
		// lang header
		let lang = 'en'
		if (locale === 'pl') {
			lang = 'pl'
		} else if (locale === 'en') {
			lang = 'en'
		}

		// currency header
		const currency = useCookie('currency').value

		const { data } = await apiCommon<IBooking>(
			groupPrefix,
			{
				method: 'POST',
				body: request,
			},
			lang,
			currency || 'PLN',
		)

		return Booking(data)
	},

	updateBooking: async (
		request: IBookingStoreRequest,
		uuid: string,
		locale: string,
		signal: AbortSignal,
		existingBooking: IBookingModel | null,
	) => {
		// lang header
		let lang = 'en'
		if (locale === 'pl') {
			lang = 'pl'
		} else if (locale === 'en') {
			lang = 'en'
		}

		// currency header
		const currency = useCookie('currency').value

		const data = await apiCommon<IBooking>(
			`${groupPrefix}/${uuid}`,
			{
				method: 'PUT',
				body: request,
				signal,
			},
			lang,
			currency || 'PLN',
		)

		return data?.data ? Booking(data?.data) : existingBooking
	},

	finalizeBooking: async (uuid: string, request: IBookingFinalizeRequest, locale: string) => {
		// currency header
		const currency = useCookie('currency').value

		const response = await apiCommon<{ data: IBooking; gateway_url: string }>(
			`${groupPrefix}/${uuid}/finalize`,
			{
				method: 'PUT',
				body: request,
			},
			locale,
			currency || 'PLN',
		)

		return {
			booking: Booking(response.data),
			gateway_url: response.gateway_url,
		}
	},
}
